/* Lyncellus Health — Theme JS */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  const drawer = document.querySelector('[data-drawer]');
  const drawerOverlay = document.querySelector('[data-drawer-overlay]');
  const drawerOpenBtns = document.querySelectorAll('[data-drawer-open]');
  const drawerCloseBtns = document.querySelectorAll('[data-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawerOverlay && drawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawerOverlay && drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  drawerOpenBtns.forEach(b => b.addEventListener('click', openDrawer));
  drawerCloseBtns.forEach(b => b.addEventListener('click', closeDrawer));
  drawerOverlay && drawerOverlay.addEventListener('click', closeDrawer);

  /* ---------- Reveal on scroll ---------- */
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-visible'));
  }

  /* ---------- Product page: thumbs ---------- */
  document.querySelectorAll('[data-product-thumbs]').forEach(group => {
    const main = document.querySelector(group.dataset.productThumbs);
    if (!main) return;
    group.querySelectorAll('[data-thumb-src]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.thumbSrc;
        const img = main.querySelector('img');
        if (img && src) img.src = src;
        group.querySelectorAll('[data-thumb-src]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Product page: qty ---------- */
  document.querySelectorAll('[data-qty]').forEach(wrap => {
    const input = wrap.querySelector('input');
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = v;
    });
    plus && plus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value || '1', 10) + 1);
      input.value = v;
    });
  });

  /* ---------- Variant selector (basic) ---------- */
  document.querySelectorAll('[data-option-group]').forEach(group => {
    group.querySelectorAll('[data-option-value]').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('[data-option-value]').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });
  });

})();
